<template>
  <div class="flex flex-col md:flex-row">
    <div class="w-64 flex-shrink-0">
      <label class="text-gray-600" for="timezone">Timezone</label>
    </div>
    <div class="md:ml-8 flex-1 mt-1 md:mt-0">
      <div v-if="! edit" class="w-full flex items-center justify-between">
        <span class="font-semibold">{{ getTimezone }}</span>
        <Edit @edit="edit = true"/>
      </div>
      <div v-else class="w-full">
        <ValidationObserver ref="timezoneForm" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(update)" method="post">
            <div>
              <ValidationProvider rules="required" vid="timezone" name="Timezone" v-slot="{ errors }">
                <div>
                  <div class="rounded-lg shadow-sm flex-1">
                    <select name="timezone" id="timezone" class="form-select guestio-form-input" v-model="form.timezone" placeholder="Timezone">
                      <option
                        v-for="(timezone, index) in timezones"
                        :value="timezone.timezone"
                        :key="`timezone-option-${index}`"
                      >
                        {{ timezone.label }}
                      </option>
                    </select>
                  </div>
                  <p class="text-red-500 text-sm mt-1 font-light" v-if="errors.length">{{ errors[0] }}</p>
                </div>
              </ValidationProvider>
            </div>
            <div class="mt-4 flex items-center justify-end">
              <SaveOrCancel @cancel="edit = false" :working="working"/>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
  import timezones from '@/mixins/timezones'
  import Edit from "@/components/shared/Edit";
  import SaveOrCancel from "@/components/shared/SaveOrCancel";

  export default {
    components: {Edit, SaveOrCancel},

    props: {
      userProp: Object,
      admin: {
        type: Boolean,
        default: false,
      }
    },

    mixins: [timezones],

    data() {
      return {
        working: false,
        edit: false,
        form: {
          timezone: this.userProp.timezone,
        }
      }
    },

    watch: {
      edit(edit) {
        if (edit) return

        this.form.timezone = this.userProp.timezone
      }
    },

    computed: {
      getTimezone() {
        let timezone = this.timezones.find(timezone => timezone.timezone == this.userProp.timezone)
        return timezone ? timezone.label : this.userProp.timezone
      },

      updateAction() {
        if (this.admin) {
          return `auth/updateAdminUser`
        }

        return `auth/updateUser`
      }
    },

    methods: {
      update() {
        this.working = true

        this.$store.dispatch(this.updateAction, this.form)
          .then(() => {
            this.working = false
            this.edit = false
          })
          .catch(error => {
            this.working = false
            if (error.response) {
              this.$refs.timezoneForm.setErrors(error.response.data.errors)
            }
          })
      }
    }
  }
</script>
